





























































import { Vue, Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { Signup as SignupRouteName, LoginInfo } from "@/employee/route-names";
import { useSignUpStore } from "@/employee/store/signup";
import { LoginRouteNames } from "@/shared/loginRoutes";
import Button from "@/shared/components/ui/Button.vue";
import Input from "@/shared/components/ui/Input.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";

const resendWaitTimeInSeconds = 30;

@Component({
  components: {
    HsaBankOnboardingFooter,
    Button,
    Input,
    LoginWrapper
  }
})
export default class VerifyEmail extends Vue {
  $validator: Validator;

  signupStore = useSignUpStore();

  verificationCode = "";
  isVerifying = false;
  resendCodeEnabled = false;

  get isSubmitDisabled () {
    return this.$validator.errors.any() || this.isVerifying;
  }

  get routeToNextStep () {
    return { name: LoginInfo, query: this.$route.query };
  }

  get routeToSignup () {
    return { name: SignupRouteName, query: this.$route.query };
  }

  mounted () {
    if (!this.signupStore.email) {
      this.goToSignupPage();
    }

    this.enableResendAfterWait();
  }

  onSubmit () {
    this.isVerifying = true;

    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          this.isVerifying = false;
          return;
        }

        this.submitVerificationCode();
      })
      .catch(() => {
        this.isVerifying = false;
      });
  }

  submitVerificationCode () {
    this.signupStore.verifyIndividualSignupEmail(this.verificationCode)
      .then(() => {
        this.$router.push(this.routeToNextStep);
      })
      .catch(() => {
        this.isVerifying = false;
      });
  }

  onResendCode () {
    this.resendCodeEnabled = false;
    this.signupStore.resendIndividualSignupEmail({ email: this.signupStore.email });
    this.enableResendAfterWait();
  }

  enableResendAfterWait () {
    setTimeout(() => {
      this.resendCodeEnabled = true;
    }, resendWaitTimeInSeconds * 1000);
  }

  onBack () {
    this.goToSignupPage();
  }

  goToSignupPage () {
    this.$router.push(this.routeToSignup);
  }
}
